function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.53775 18.6191C14.442 18.6191 18.5026 14.5498 18.5026 9.6543C18.5026 4.75 14.4333 0.689453 9.52896 0.689453C4.63345 0.689453 0.572905 4.75 0.572905 9.6543C0.572905 14.5498 4.64224 18.6191 9.53775 18.6191ZM4.87955 9.64551C4.87955 9.44336 4.94986 9.30273 5.13443 9.11816L8.19302 6.04199C8.31607 5.91895 8.47427 5.85742 8.66763 5.85742C9.04556 5.85742 9.32681 6.13867 9.32681 6.5166C9.32681 6.70996 9.23892 6.87695 9.12466 7.00879L7.99966 8.125L6.90982 9.03906L8.82583 8.95996H13.528C13.9235 8.95996 14.2135 9.24121 14.2135 9.64551C14.2135 10.041 13.9323 10.3223 13.528 10.3223H8.82583L6.90103 10.252L7.99966 11.166L9.12466 12.2822C9.24771 12.4053 9.32681 12.5723 9.32681 12.7656C9.32681 13.1436 9.04556 13.4336 8.66763 13.4336C8.47427 13.4336 8.31607 13.3633 8.19302 13.2402L5.13443 10.1729C4.96744 10.0059 4.87955 9.84766 4.87955 9.64551Z",
  fill: "white"
});

var SvgArrowLeftFilled = function SvgArrowLeftFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeftFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left-filled.a0fad1f8.svg";
export { ForwardRef as ReactComponent };